module.exports = __webpack_public_path__ + "static/SerifGothicStd-Heavy-49b8ae04d8e5b345ecb43eb15e74e033.woff2";